import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import uniqueId from 'lodash/uniqueId';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd';
import { Breakpoint } from '../../../../helpers/MediaQuery';
import ClearFilters from '../ClearFilters';
import { setMoreFiltersOpen } from '../../../../actions';
import OverlayFilterWrapper from './OverlayFilterWrapper';

let $body;
let $footer;

const MoreFiltersOverlay = ({ children }) => {
  const { moreFiltersOpen } = useSelector((state) => state.searchFilters);
  const { meta } = useSelector((state) => state.searchResults);

  const dispatch = useDispatch();
  const filtersOpenClassName = moreFiltersOpen ? 'open' : null;
  const closeFilterPanel = () => dispatch(setMoreFiltersOpen(false));

  useEffect(() => {
    $body = jQuery('body');

    const bottomSearchLinks = jQuery('.search-links-wrapper');
    $footer = bottomSearchLinks.length ? bottomSearchLinks : jQuery('.footer');
  }, []);

  useEffect(() => {
    $body.toggleClass('scroll-block', !!moreFiltersOpen);

    const scrollPosition = window.innerHeight + jQuery(document).scrollTop();
    const footerTopPosition = $footer.offset().top;

    if (moreFiltersOpen === true && (scrollPosition > footerTopPosition)) {
      window.scrollTo(0, (footerTopPosition - window.innerHeight));
    }
  }, [moreFiltersOpen]);

  return (
    <div className={`advanced-filter-panel-wrapper ${filtersOpenClassName}`}>
      <div className={`advanced-filter-panel ${filtersOpenClassName}`}>
        {children.map((child) => (
          child
            ? (
              <Breakpoint {...child.props} key={uniqueId(child.props.filterName)}>
                <OverlayFilterWrapper
                  key={uniqueId(child.props.filterName)}
                  filterName={child.props.filterName}
                  filterTitle={child.props.filterTitle}
                >
                  {child}
                </OverlayFilterWrapper>
              </Breakpoint>
            )
            : null
        ))}
      </div>
      {moreFiltersOpen && (
        <div className="listing-filter-actions open">
          <span className="cancel-button">
            <Button onClick={closeFilterPanel} size="large" type="primary">
              See results
              {meta && (<span>&nbsp;({meta.total || 0} found)</span>)}
            </Button>
          </span>
          <span className="pull-right clear-filters"><ClearFilters /></span>
        </div>
      )}
    </div>
  );
};

MoreFiltersOverlay.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
};

export default MoreFiltersOverlay;
